
import {classifyBoxScan} from './boxChampScanRouter';

export const SUBSTITUTION_IDLE = 'idle';
export const SUBSTITUTION_PENDING = 'pending';

export function substitutionStep(value, {expectedBox, catalog, pending, settings} = {}) {
  // `settings` is threaded through to classifyBoxScan for a tenant-cleanup step
  // (processBarCode/removeStringFromBarcode) landing on a sister branch
  // (fix/groov-4994-guided-silent-failures). classifyBoxScan on this branch does not
  // read it yet, so this is inert here — passing it now just means the two branches
  // compose without a second wiring pass once that lands.
  const result = classifyBoxScan(value, {
    expectedBox,
    catalog,
    pendingSubstitution: pending,
    settings,
  });

  switch (result.kind) {
    case 'substitution_confirm':
      return {
        state: SUBSTITUTION_IDLE,
        pending: null,
        handled: true,
        commitBoxTypeId: result.boxType.id,
      };
    case 'substitution_prompt':
    case 'substitution_switch':
      return {
        state: SUBSTITUTION_PENDING,
        pending: result.boxType,
        handled: true,
        prompt: `Using ${result.boxType.name} instead? Scan it again to confirm.`,
      };
    case 'confirm_expected':
      return {
        state: SUBSTITUTION_IDLE,
        pending: null,
        handled: true,
        cancelled: Boolean(pending),
      };
    default:
      return {
        state: pending ? SUBSTITUTION_PENDING : SUBSTITUTION_IDLE,
        pending: pending || null,
        handled: false,
      };
  }
}
